import React from "react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { options } from "../../utils/richTextOptions";

const FirstIntroSection = ({ intro, backgroundColor, maxWidth }) => {
  return (
    <div
      className={`relative pt-5 md:pt-[30px] pb-[15px] md:pb-5 box-border text-black ${backgroundColor}`}
    >
      <div className="relative block px-5 2xl:px-[90px] z-[2]">
        <div className={`${maxWidth} block w-full mx-auto`}>
          <div className="text-[15px] md:text-base tracking-wide leading-7 text-center">
            {documentToReactComponents(JSON.parse(intro.raw), options)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FirstIntroSection;
